<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.show_offer") }}</h4>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Image Upload Input -->
          <base-image-upload-input
            col="12"
            identifier="image"
            :placeholder="$t('PLACEHOLDERS.image')"
            @selectImage="selectImage"
            required
            :preSelectedImage="data.image.path"
          />
          <!-- End:: Image Upload Input -->

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.offer_name')"
            v-model.trim="data.nameAr"
            required
          />
          <!-- End:: Name Input -->

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.nameEn"
            required
          />

          <!-- start description -->
          <base-input
            :placeholder="$t('TABLES.ServicesTypes.descriptionAr')"
            v-model.trim="data.descAr"
            col="6"
            type="textarea"
            required
          />
          <!-- end description -->
          <base-picker-input
            col="6"
            type="date"
            :disabledDate="disabledDate"
            :placeholder="$t('PLACEHOLDERS.start_date')"
            v-model.trim="data.publish_start_date"
            required
          />

          <base-picker-input
            col="6"
            type="date"
            :disabledDate="disabledDate"
            :placeholder="$t('PLACEHOLDERS.end_date')"
            v-model.trim="data.publish_end_date"
            required
          />

          <!-- Start:: Main Category Input -->
          <base-select-input
            col="6"
            :optionsList="allMainCategories"
            :placeholder="$t('PLACEHOLDERS.main_category_name')"
            v-model="data.main_category_id"
            required
            @input="handleMainCategoryChange"
          />
          <!-- End:: Main Category Input -->

          <!-- Start:: Sub Category Input -->
          <base-select-input
            col="6"
            :optionsList="allSubCategories"
            :placeholder="$t('PLACEHOLDERS.sub_category_name')"
            v-model="data.sub_category_id"
            multiple
            required
            @input="handleSubCategoryChange"
          />
          <!-- End:: Sub Category Input -->

          <!-- start : types input -->
          <base-select-input
            col="6"
            :optionsList="types"
            :placeholder="$t('PLACEHOLDERS.category_name')"
            v-model="data.type_id"
            multiple
            required
            @input="handleTypeChange"
          />
          <!-- end : types input -->

          <!-- Start:: Services Input -->
          <base-select-input
            col="6"
            :optionsList="services"
            :placeholder="$t('PLACEHOLDERS.services')"
            v-model="data.service_id"
            multiple
            required
          />
          <!-- End:: Services Input -->

          <!-- start : discount -->
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.discountPercentage')"
            v-model.trim="data.discountPercentage"
            required
          />
          <!-- end : discount -->

          <!-- Start:: Deactivate Switch Input -->
          <div class="input_wrapper switch_wrapper my-5">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
            ></v-switch>
          </div>
          <!-- End:: Deactivate Switch Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "EditOffer",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      file: null,
      fileType: "",

      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          file: null,
        },
        nameAr: null,
        nameEn: null,
        descAr: null,
        active: true,
        publish_start_date: null,
        publish_end_date: null,
        sub_category_id: null,
        main_category_id: null,
        discountPercentage: null,
        service_id: null,
        type_id: null,
      },
      allMainCategories: [],
      allSubCategories: [],
      services: [],
      types: [],

      // End:: Data Collection To Send

      arabicRegex: /^[\u0600-\u06FF\s]+$/,
      EnRegex: /[\u0600-\u06FF]/,
    };
  },

  computed: {},

  methods: {
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },

    disabledDate(current) {
      return current && current < moment().startOf("day");
    },

    onCopy(event) {
      event.preventDefault();
    },
    onPaste(event) {
      event.preventDefault();
    },

    validateInput() {
      // Remove non-Arabic characters from the input
      this.data.nameAr = this.data.nameAr.replace(/[^\u0600-\u06FF\s]/g, "");
    },
    removeArabicCharacters() {
      this.data.nameEn = this.data.nameEn.replace(this.EnRegex, "");
    },

    handleFileSelected({ file, fileType }) {
      this.file = file; // Store the selected file in your data
      this.fileType = fileType; // Store the selected file in your data
    },
    handleFileRemoved() {
      this.file = null; // Reset the file when it's removed
      this.fileType = "";
    },

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      if (!this.data.nameAr) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.nameAr"));
        return;
        // } else if (!this.data.nameEn) {
        //   this.isWaitingRequest = false;
        //   this.$message.error(this.$t("VALIDATION.nameEn"));
        //   return;
      } else if (!this.data.publish_start_date) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.startDate"));
        return;
      } else if (!this.data.publish_end_date) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.endDate"));
        return;
      } else {
        this.submitForm();
        return;
      }
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data
      REQUEST_DATA.append("name[ar]", this.data.nameAr || "");
      REQUEST_DATA.append("name[en]", this.data.nameAr || "");
      REQUEST_DATA.append("description", this.data.descAr || "");

      if (this.data.image && this.data.image.file) {
        REQUEST_DATA.append("image", this.data.image.file);
      }

      REQUEST_DATA.append("start_date", this.data.publish_start_date || "");
      REQUEST_DATA.append("end_date", this.data.publish_end_date || "");

      // Append Main Category
      REQUEST_DATA.append("category_id", this.data.main_category_id.id);

      // append services
      this.data.service_id.forEach((element, index) => {
        REQUEST_DATA.append(`service_ids[${index}][]`, element.id);
      });

      // append Sub Categories
      this.data.sub_category_id.forEach((element, index) => {
        REQUEST_DATA.append(`sub_category_ids[${index}]`, element.id);
      });

      // append types
      this.data.type_id.forEach((element, index) => {
        REQUEST_DATA.append(`type_ids[${index}]`, element.id);
      });

      // Append Discount Ratio
      REQUEST_DATA.append("discount_ratio", this.data.discountPercentage || "");

      // Append Active Status
      REQUEST_DATA.append("is_active", this.data.active);

      REQUEST_DATA.append("_method", "PUT");
      // Start:: Append Request Data

      try {
        await this.$axios({
          method: "POST",
          url: `offers/${this.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/offers/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form

    // start all ads data
    async getOfferData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `offers/${this.$route.params.id}`,
        });
        this.data.image.path = res.data.data.Offer.image;
        this.data.nameAr = res.data.data.Offer.name;
        this.data.descAr = res.data.data.Offer.description;

        this.data.main_category_id = res.data.data.Offer.main_category;

        this.data.sub_category_id = res.data.data.Offer.sub_categories;

        this.data.service_id = res.data.data.Offer.products[0].service;

        this.data.type_id = res.data.data.Offer.products[0].type;

        this.data.discountPercentage = res.data.data.Offer.discount_ratio;

        this.data.nameEn = res.data.data.Offer.name;
        this.data.publish_start_date = res.data.data.Offer.start_date;
        this.data.publish_end_date = res.data.data.Offer.end_date;
        this.data.active = res.data.data.Offer.is_active;

        // console.log(res.data.body.add_space)
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // end all ads data

    async getMainCategories() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `categories`,
          params: {
            is_allowed: 1,
          },
        });
        // console.log("main categories api reponse : ", res);
        if (res.data.data) {
          this.allMainCategories = res.data.data.map((el) => ({
            id: el.id,
            name: el.name,
          }));
        } else {
          console.error("Unexpected response structure: ", res);
          this.allMainCategories = [];
        }
      } catch (error) {
        console.error("console Error fetching main categories : ", error);
        this.$message.error(
          error.response?.data?.message ||
            "message error fetching main categories"
        );
      }
    },

    async getSubCategories(categoryId) {
      console.log("Fetching categoryId:", categoryId);
      try {
        let res = await this.$axios({
          method: "GET",
          url: `sub-categories?categoryId=${categoryId}`,
          params: {
            is_allowed: 1,
          },
        });

        // console.log("Sub-categories API Response:", res);

        if (res && res.data && res.data.data && Array.isArray(res.data.data)) {
          this.allSubCategories = res.data.data.map((el) => ({
            id: el?.id,
            name: el?.name,
          }));
          console.log("Updated Sub-categories:", this.allSubCategories);
        } else {
          console.error("Unexpected response structure:", res);
          this.allSubCategories = [];
        }
      } catch (error) {
        console.error("Error fetching sub categories:", error);
        this.$message.error(
          error.response?.data?.message || "Error fetching categories"
        );
      }
    },

    async getTypes(subCategoryIds) {
      console.log("Fetching subCategoryIds for types:", subCategoryIds);
      try {
        // If subCategoryIds is an array, join into a comma-separated string
        const ids = Array.isArray(subCategoryIds)
          ? subCategoryIds.join(",")
          : subCategoryIds;

        let res = await this.$axios({
          method: "GET",
          url: `types?subCategoryIds=${ids}`,
          params: {
            is_allowed: 1,
          },
        });

        if (res.data.data && Array.isArray(res.data.data)) {
          this.types = res.data.data.map((type) => ({
            id: type.id,
            name: type.name,
          }));
          console.log("Mapped types:", this.types);
        } else {
          console.error("Unexpected response structure:", res);
          this.types = [];
        }
      } catch (error) {
        console.error("Error fetching types:", error);
        this.$message.error(
          error.response?.data?.message || "Error fetching types"
        );
      }
    },

    async getServices(TypeId) {
      console.log("Fetching TypeId for services:", TypeId);
      try {
        // If TypeId is an array, join into a comma-separated string
        const ids = Array.isArray(TypeId) ? TypeId.join(",") : TypeId;

        let res = await this.$axios({
          method: "GET",
          url: `services?typeId=${ids}`,
          params: {
            is_allowed: 1,
          },
        });

        if (res.data.data && Array.isArray(res.data.data)) {
          this.services = res.data.data.map((service) => ({
            id: service.id,
            name: service.name,
          }));
          console.log("Mapped services:", this.services);
        } else {
          console.error("Unexpected response structure:", res);
          this.services = [];
        }
      } catch (error) {
        console.error("Error fetching services:", error);
        this.$message.error(
          error.response?.data?.message || "Error fetching services"
        );
      }
    },

    handleMainCategoryChange(newVal) {
      // Handle the change event and call the appropriate method
      if (newVal && newVal.id) {
        this.getSubCategories(newVal.id);
      }
    },

    handleSubCategoryChange(newVal) {
      // Handle the change event and call the appropriate method
      if (Array.isArray(newVal)) {
        this.getTypes(newVal.map((item) => item.id));
      } else if (newVal && newVal.id) {
        this.getTypes(newVal.id);
      }
    },

    handleTypeChange(newVal) {
      if (Array.isArray(newVal)) {
        this.getServices(newVal.map((item) => item.id));
      } else if (newVal && newVal.id) {
        this.getServices([newVal.id]);
      } else {
        this.getServices([]);
      }
    },
  },

  created() {
    // Start:: Fire Methods
    this.getOfferData();
    this.getMainCategories();
    // End:: Fire Methods
  },
};
</script>

<style>
.preview-container img,
.preview-container video {
  max-width: 100%;
  max-height: 200px;
  border: 1px solid #ccc;
  border-radius: 20px;
}
</style>
